/**
 * Matching for the searchable top-bar switchers (organization, project,
 * scene): what counts as a hit for the typed text, and in which order hits
 * are listed.
 */

// Case and accents don't matter when searching: "a" also finds "Ärzte",
// "strasse" finds "Straße".
export const foldForSearch = (text: string) =>
	text
		.normalize("NFD")
		.replace(/\p{M}/gu, "")
		.toLocaleLowerCase("de")
		.replace(/ß/g, "ss");

// Where the typed text occurs in the label, or -1. Anywhere counts, so "test"
// finds "Hegiastest".
export const matchPosition = (label: string, input: string) =>
	foldForSearch(label).indexOf(foldForSearch(input.trim()));

// Names that start with the typed text first, then the ones that only contain
// it. Array.prototype.sort is stable, so each group keeps the order it came in.
export const compareByMatchStart = (
	labelA: string,
	labelB: string,
	input: string,
) =>
	Number(matchPosition(labelB, input) === 0) -
	Number(matchPosition(labelA, input) === 0);
